const TrackingConstants = {
  GCLID_COOKIE_NAME: '__gclid',
  GCLID_COOKIE_EXPIRATION: 60 * 60 * 24 * 5,
  FBCLID_COOKIE_NAME: '__fbclid',
  FBCLID_COOKIE_EXPIRATION: 60 * 60 * 24 * 5,
  USER_IDENTITY_COOKIE_NAME: 'signonidentity',
  UTM_COOKIE_EXPIRATION: 60 * 60 * 24 * 5,
  UTM_COOKIE_NAME: '__utm_params',
  UTM_PARAM_NAMES: [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ],
}; // Triggered when the user attempts to sign-up. May fire more than once as the user interacts with the form(s).

export const SIGNUP_INTENT_EVENT = 'auth: signup_intent'; // Triggered when the user successfully completes the sign up process.
export const TRIGGER_SCROLL_TRACKING = 'ScrollDistance'; // Triggers scroll tracking via GTM tag
export const SIGNUP_CONVERSION_EVENT = 'auth: signup'; // Triggered when a user clicks the `Sign Up` button in the header

export const SIGNUP_PRE_INTENT_EVENT = 'auth: signup_pre_intent';
export default TrackingConstants;
